import http from "./http";
var baseUrl = "/common-web";

/**
 * 制度管理
 * */
// 查询制度列表
const getRuleListService = (params) => {
    console.log(params)
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/rule/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询有效部门列表
 * */
// 查询制度列表
const getDeptActiveListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/appuser-web/dept/active/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
const getDeptListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/appuser-web/dept", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

//查询本部门及有效子部门列表
const getDeptSubOwnListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/appuser-web/dept/sub/own/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 新建制度
const addRuleService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+"/system/rule", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 修改制度
const modifyRuleService = (params) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+"/system/rule", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 修改制度状态
const setRuleStatusService = (params) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+"/system/rule/status", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 制度详情
const getRuleDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/rule/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 制度下载
const downloadRuleService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/rule/detail/downloadList", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 查询制度授权
const getPermissionService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/rule/permission", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 删除制度
const deleteRuleService = (params) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+"/system/rule", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 查询制度授权
const getPermissionCheckService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/rule/permission/check", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

//获取临时下载地址
const getTempUrlService = param => {
    return new Promise((resolve, reject) => {
        http
            .post("/common-web/oss/getTempUrl", param, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 查询全部部门树列表
const getAllDeptListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/appuser-web/dept/all/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
export {
    getRuleListService,
    getDeptActiveListService,
    getDeptListService,
    getDeptSubOwnListService,
    addRuleService,
    modifyRuleService,
    setRuleStatusService,
    getRuleDetailService,
    downloadRuleService,
    getPermissionService,
    deleteRuleService,
    getPermissionCheckService,
    getTempUrlService,

    getAllDeptListService,
}
